// TODO if there are custom client needs modifiers may need to be moved to a database in milestone 2

import { getmodifiers } from './codesets';

// use auto complete in entry
export interface CptModifier {
  code: string;
  description?: string;
  locationCode?:string;
  custom?: boolean;
}

export let cptModifiers: CptModifier[] = [
  /* 1 */
  {
    code: '1P',
    description: 'Medi-Cal Modifier',
  },

  /* 2 */
  {
    code: '21',
    description: 'PROLONGED EVALUATION AND MANAGEMENT SERVICES: WHEN THE FACE-TO-FACE OR FLOOR/UNIT SERVICE(S) PROVIDED IS PROLONGED OR OTHERWI',
  },

  /* 3 */
  {
    code: '22',
    description: 'UNUSUAL PROCEDURAL SERVICES: WHEN THE SERVICE(S) PROVIDED IS GREATER THAN THAT USUALLY REQUIRED FOR THE LISTED PROCEDURE, IT ',
  },

  /* 4 */
  {
    code: '23',
    description: 'UNUSUAL ANESTHESIA: OCCASIONALLY, A PROCEDURE, WHICH USUALLY REQUIRES EITHER NO ANESTHESIA OR LOCAL ANESTHESIA, BECAUSE OF UN',
  },

  /* 5 */
  {
    code: '24',
    description: 'UNRELATED EVALUATION AND MANAGEMENT SERVICE BY THE SAME PHYSICIAN DURING A POSTOPERATIVE PERIOD: THE PHYSICIAN MAY NEED TO IN',
  },

  /* 6 */
  {
    code: '25',
    description: 'SIGNIFICANT, SEPARATELY IDENTIFIABLE EVALUATION AND MANAGEMENT SERVICE BY THE SAME PHYSICIAN ON THE SAME DAY OF THE PROCEDURE',
  },

  /* 7 */
  {
    code: '26',
    description: 'PROFESSIONAL COMPONENT: CERTAIN PROCEDURES ARE A COMBINATION OF A PHYSICIAN COMPONENT AND A TECHNICAL COMPONENT. WHEN THE PHY',
  },

  /* 8 */
  {
    code: '27',
    description: 'MULTIPLE OUTPATIENT HOSPITAL E/M ENCOUNTERS ON THE SAME DATE: FOR HOSPITAL OUTPATIENT REPORTING PURPOSES, UTILIZATION OF HOSP',
  },

  /* 9 */
  {
    code: '2P',
    description: 'Medi-Cal Modifier',
  },

  /* 10 */
  {
    code: '32',
    description: 'MANDATED SERVICES: SERVICES RELATED TO MANDATED CONSULTATION AND/OR RELATED SERVICES (EG, PRO, THIRD PARTY PAYER, GOVERNMENTA',
  },

  /* 11 */
  {
    code: '3P',
    description: 'Medi-Cal Modifier',
  },

  /* 12 */
  {
    code: '47',
    description: 'ANESTHESIA BY SURGEON: REGIONAL OR GENERAL ANESTHESIA PROVIDED BY THE SURGEON MAY BE REPORTED BY ADDING MODIFIER 47 TO THE BA',
  },

  /* 13 */
  {
    code: '50',
    description: 'BILATERAL PROCEDURE: UNLESS OTHERWISE IDENTIFIED IN THE LISTINGS, BILATERAL PROCEDURES THAT ARE PERFORMED AT THE SAME OPERATI',
  },

  /* 14 */
  {
    code: '51',
    description: 'MULTIPLE PROCEDURES: WHEN MULTIPLE PROCEDURES, OTHER THAN E/M SERVICES, ARE PERFORMED AT THE SAME SESSION BY THE SAME PROVIDE',
  },

  /* 15 */
  {
    code: '52',
    description: 'REDUCED SERVICES: UNDER CERTAIN CIRCUMSTANCES A SERVICE OR PROCEDURE IS PARTIALLY REDUCED OR ELIMINATED AT THE PHYSICIANS DI',
  },

  /* 16 */
  {
    code: '53',
    description: 'DISCONTINUED PROCEDURE: UNDER CERTAIN CIRCUMSTANCES, THE PHYSICIAN MAY ELECT TO TERMINATE A SURGICAL OR DIAGNOSTIC PROCEDURE.',
  },

  /* 17 */
  {
    code: '54',
    description: 'SURGICAL CARE ONLY: WHEN ONE PHYSICIAN PERFORMS A SURGICAL PROCEDURE AND ANOTHER PROVIDES PREOPERATIVE AND/OR POSTOPERATIVE M',
  },

  /* 18 */
  {
    code: '55',
    description: 'POSTOPERATIVE MANAGEMENT ONLY: WHEN ONE PHYSICIAN PERFORMED THE POSTOPERATIVE MANAGEMENT AND ANOTHER PHYSICIAN PERFORMED THE ',
  },

  /* 19 */
  {
    code: '56',
    description: 'PREOPERATIVE MANAGEMENT ONLY: WHEN ONE PHYSICIAN PERFORMED THE PREOPERATIVE CARE AND EVALUATION AND ANOTHER PHYSICIAN PERFORM',
  },

  /* 20 */
  {
    code: '57',
    description: 'DECISION FOR SURGERY: AN EVALUATION AND MANAGEMENT SERVICE THAT RESULTED IN THE INITIAL DECISION TO PERFORM THE SURGERY MAY B',
  },

  /* 21 */
  {
    code: '58',
    description: 'STAGED OR RELATED PROCEDURE OR SERVICE BY THE SAME PHYSICIAN DURING THE POSTOPERATIVE PERIOD: THE PHYSICIAN MAY NEED TO INDIC',
  },

  /* 22 */
  {
    code: '59',
    description: 'DISTINCT PROCEDURAL SERVICE: UNDER CERTAIN CIRCUMSTANCES, THE PHYSICIAN MAY NEED TO INDICATE THAT A PROCEDURE OR SERVICE WAS ',
  },

  /* 23 */
  {
    code: '62',
    description: 'TWO SURGEONS: WHEN TWO SURGEONS WORK TOGETHER AS PRIMARY SURGEONS PERFORMING DISTINCT PART(S) OF A PROCEDURE, EACH SURGEON SH',
  },

  /* 24 */
  {
    code: '63',
    description: 'PROCEDURE PERFORMED ON INFANTS LESS THAN 4 KG: PROCEDURES PERFORMED ON NEONATES AND INFANTS UP TO A PRESENT BODY WEIGHT OF 4 ',
  },

  /* 25 */
  {
    code: '66',
    description: 'SURGICAL TEAM: UNDER SOME CIRCUMSTANCES, HIGHLY COMPLEX PROCEDURES (REQUIRING THE CONCOMITANT SERVICES OF SEVERAL PHYSICIANS,',
  },

  /* 26 */
  {
    code: '73',
    description: 'DISCONTINUED OUT-PATIENT HOSPITAL/AMBULATORY SURGERY CENTER (ASC) PROCEDURE PRIOR TO THE ADMINISTRATION OF ANESTHESIA: DUE TO',
  },

  /* 27 */
  {
    code: '74',
    description: 'DISCONTINUED OUT-PATIENT HOSPITAL/AMBULATORY SURGERY CENTER (ASC) PROCEDURE AFTER ADMINISTRATION OF ANESTHESIA: DUE TO EXTENU',
  },

  /* 28 */
  {
    code: '76',
    description: 'REPEAT PROCEDURE BY SAME PHYSICIAN: THE PHYSICIAN MAY NEED TO INDICATE THAT A PROCEDURE OR SERVICE WAS REPEATED SUBSEQUENT TO',
  },

  /* 29 */
  {
    code: '77',
    description: 'REPEAT PROCEDURE BY ANOTHER PHYSICIAN: THE PHYSICIAN MAY NEED TO INDICATE THAT A BASIC PROCEDURE OR SERVICE PERFORMED BY ANOT',
  },

  /* 30 */
  {
    code: '78',
    description: 'RETURN TO THE OPERATING ROOM FOR A RELATED PROCEDURE DURING THE POSTOPERATIVE PERIOD: THE PHYSICIAN MAY NEED TO INDICATE THAT',
  },

  /* 31 */
  {
    code: '79',
    description: 'UNRELATED PROCEDURE OR SERVICE BY THE SAME PHYSICIAN DURING THE POSTOPERATIVE PERIOD: THE PHYSICIAN MAY NEED TO INDICATE THAT',
  },

  /* 32 */
  {
    code: '80',
    description: 'ASSISTANT SURGEON: SURGICAL ASSISTANT SERVICES MAY BE IDENTIFIED BY ADDING MODIFIER 80 TO THE USUAL PROCEDURE NUMBER(S). ',
  },

  /* 33 */
  {
    code: '81',
    description: 'MINIMUM ASSISTANT SURGEON: MINIMUM SURGICAL ASSISTANT SERVICES ARE IDENTIFIED BY ADDING MODIFIER 81 TO THE USUAL PROCEDURE NU',
  },

  /* 34 */
  {
    code: '82',
    description: 'ASSISTANT SURGEON (WHEN QUALIFIED RESIDENT SURGEON NOT AVAILABLE): THE UNAVAILABILITY OF A QUALIFIED RESIDENT SURGEON IS A PR',
  },

  /* 35 */
  {
    code: '8P',
    description: 'Medi-Cal Modifier',
  },

  /* 36 */
  {
    code: '90',
    description: 'REFERENCE (OUTSIDE) LABORATORY: WHEN LABORATORY PROCEDURES ARE PERFORMED BY A PARTY OTHER THAN THE TREATING OR REPORTING PHYS',
  },

  /* 37 */
  {
    code: '91',
    description: 'REPEAT CLINICAL DIAGNOSTIC LABORATORY TEST: IN THE COURSE OF TREATMENT OF THE PATIENT, IT MAY BE NECESSARY TO REPEAT THE SAME',
  },

  /* 38 */
  {
    code: '92',
    description: 'No description for modifier',
  },

  /* 39 */
  {
    code: '99',
    description: 'MULTIPLE MODIFIERS: UNDER CERTAIN CIRCUMSTANCES TWO OR MORE MODIFIERS MAY BE NECESSARY TO COMPLETELY DELINEATE A SERVICE. IN ',
  },

  /* 40 */
  {
    code: 'A1',
    description: 'Dressing for one wound',
  },

  /* 41 */
  {
    code: 'A2',
    description: 'Dressing for two wounds',
  },

  /* 42 */
  {
    code: 'A3',
    description: 'Dressing for three wounds',
  },

  /* 43 */
  {
    code: 'A4',
    description: 'Dressing for four wounds',
  },

  /* 44 */
  {
    code: 'A5',
    description: 'Dressing for five wounds',
  },

  /* 45 */
  {
    code: 'A6',
    description: 'Dressing for six wounds',
  },

  /* 46 */
  {
    code: 'A7',
    description: 'Dressing for seven wounds',
  },

  /* 47 */
  {
    code: 'A8',
    description: 'Dressing for eight wounds',
  },

  /* 48 */
  {
    code: 'A9',
    description: 'Dressing for nine or more wounds',
  },

  /* 49 */
  {
    code: 'AA',
    description: 'Anesthesia services performed personally by anesthesiologist',
  },

  /* 50 */
  {
    code: 'AD',
    description: 'Medical supervision by a physician: more than four concurrent anesthesia procedures',
  },

  /* 51 */
  {
    code: 'AE',
    description: 'Registered dietician',
  },

  /* 52 */
  {
    code: 'AF',
    description: 'Specialty physician',
  },

  /* 53 */
  {
    code: 'AG',
    description: 'No description for modifier',
  },

  /* 54 */
  {
    code: 'AH',
    description: 'Clinical psychologist',
  },

  /* 55 */
  {
    code: 'AI',
    description: 'Principal physician of record',
  },

  /* 56 */
  {
    code: 'AJ',
    description: 'Clinical social worker',
  },

  /* 57 */
  {
    code: 'AK',
    description: 'Non participating physician',
  },

  /* 58 */
  {
    code: 'AM',
    description: 'Physician, team member service',
  },

  /* 59 */
  {
    code: 'AP',
    description: 'Determination of refractive state was not performed in the course of diagnostic ophthalmological examination',
  },

  /* 60 */
  {
    code: 'AQ',
    description: 'Physician providing a service in an unlisted health professional shortage area (HPSA)',
  },

  /* 61 */
  {
    code: 'AR',
    description: 'Physician provider services in a physician scarcity area',
  },

  /* 62 */
  {
    code: 'AS',
    description: 'Physician assistant, nurse practitioner, or clinical nurse specialist services for assistant at surgery',
  },

  /* 63 */
  {
    code: 'AT',
    description: 'Acute treatment (this modifier should be used when reporting service 98940, 98941, 98942)',
  },

  /* 64 */
  {
    code: 'AU',
    description: 'Item furnished in conjunction with a urological, ostomy, or tracheostomy supply',
  },

  /* 65 */
  {
    code: 'AV',
    description: 'Item furnished in conjunction with a prosthetic device, prosthetic or orthotic',
  },

  /* 66 */
  {
    code: 'AW',
    description: 'Item furnished in conjunction with a surgical dressing',
  },

  /* 67 */
  {
    code: 'AX',
    description: 'Item furnished in conjunction with dialysis services',
  },

  /* 68 */
  {
    code: 'AY',
    description: 'Item or service furnished to an ESRD patient that is not for the treatment of ESRD',
  },

  /* 69 */
  {
    code: 'AZ',
    description: 'Physician providing a service in a dental health professional shortage area for the purpose of an electronic health record incen',
  },

  /* 70 */
  {
    code: 'BA',
    description: 'Item furnished in conjunction with parenteral enteral nutrition (PEN) services',
  },

  /* 71 */
  {
    code: 'BL',
    description: 'Special acquisition of blood and blood products',
  },

  /* 72 */
  {
    code: 'BO',
    description: 'Orally administered nutrition, not by feeding tube',
  },

  /* 73 */
  {
    code: 'BP',
    description: 'The beneficiary has been informed of the purchase and rental options and has elected to purchase the item',
  },

  /* 74 */
  {
    code: 'BR',
    description: 'The beneficiary has been informed of the purchase and rental options and has elected to rent the item',
  },

  /* 75 */
  {
    code: 'BU',
    description: 'The beneficiary has been informed of the purchase and rental options and after 30 days has not informed the supplier of his/her ',
  },

  /* 76 */
  {
    code: 'CA',
    description: 'Procedure payable only in the inpatient setting when performed emergently on an outpatient who expires prior to admission',
  },

  /* 77 */
  {
    code: 'CB',
    description: 'Service ordered by a renal dialysis facility (RDF) physician as part of the ESRD beneficiarys dialysis benefit, is not part of t',
  },

  /* 78 */
  {
    code: 'CC',
    description: 'Procedure code change (use cc when the procedure code submitted was changed either for administrative reasons or because an inco',
  },

  /* 79 */
  {
    code: 'CD',
    description: 'AMCC test has been ordered by an ESRD facility or MCP physician that is part of the composite rate and is not separately billabl',
  },

  /* 80 */
  {
    code: 'CE',
    description: 'AMCC test has been ordered by an ESRD facility or MCP physician that is a composite rate test but is beyond the normal frequency',
  },

  /* 81 */
  {
    code: 'CF',
    description: 'AMCC test has been ordered by an ESRD facility or MCP physician that is not part of the composite rate and is separately billabl',
  },

  /* 82 */
  {
    code: 'CG',
    description: 'Policy criteria applied',
  },

  /* 83 */
  {
    code: 'CH',
    description: '0 percent impaired, limited or restricted',
  },

  /* 84 */
  {
    code: 'CI',
    description: 'At least 1 percent but less than 20 percent impaired, limited or restricted',
  },

  /* 85 */
  {
    code: 'CJ',
    description: 'At least 20 percent but less than 40 percent impaired, limited or restricted',
  },

  /* 86 */
  {
    code: 'CK',
    description: 'At least 40 percent but less than 60 percent impaired, limited or restricted',
  },

  /* 87 */
  {
    code: 'CL',
    description: 'At least 60 percent but less than 80 percent impaired, limited or restricted',
  },

  /* 88 */
  {
    code: 'CM',
    description: 'At least 80 percent but less than 100 percent impaired, limited or restricted',
  },

  /* 89 */
  {
    code: 'CN',
    description: '100 percent impaired, limited or restricted',
  },

  /* 90 */
  {
    code: 'CR',
    description: 'Catastrophe/disaster related',
  },

  /* 91 */
  {
    code: 'CS',
    description: 'Item or service related, in whole or in part, to an illness, injury, or condition that was caused by or exacerbated by the effec',
  },

  /* 92 */
  {
    code: 'E1',
    description: 'UPPER LEFT, EYELID ',
  },

  /* 93 */
  {
    code: 'E2',
    description: 'LOWER LEFT, EYELID ',
  },

  /* 94 */
  {
    code: 'E3',
    description: 'UPPER RIGHT, EYELID',
  },

  /* 95 */
  {
    code: 'E4',
    description: 'LOWER RIGHT, EYELID',
  },

  /* 96 */
  {
    code: 'EA',
    description: 'Erythropoetic stimulating agent (esa) administered to treat anemia due to anti-cancer chemotherapy',
  },

  /* 97 */
  {
    code: 'EB',
    description: 'Erythropoetic stimulating agent (esa) administered to treat anemia due to anti-cancer radiotherapy',
  },

  /* 98 */
  {
    code: 'EC',
    description: 'Erythropoetic stimulating agent (esa) administered to treat anemia not due to anti-cancer radiotherapy or anti-cancer chemothera',
  },

  /* 99 */
  {
    code: 'ED',
    description: 'Hematocrit level has exceeded 39% (or hemoglobin level has exceeded 13.0 g/dl) for 3 or more consecutive billing cycles immediat',
  },

  /* 100 */
  {
    code: 'EE',
    description: 'Hematocrit level has not exceeded 39% (or hemoglobin level has not exceeded 13.0 g/dl) for 3 or more consecutive billing cycles ',
  },

  /* 101 */
  {
    code: 'EJ',
    description: 'Subsequent claims for a defined course of therapy, e.g., EPO, sodium hyaluronate, Infliximab',
  },

  /* 102 */
  {
    code: 'EM',
    description: 'Emergency reserve supply (for ESRD benefit only)',
  },

  /* 103 */
  {
    code: 'EP',
    description: 'Service provided as part of Medicaid early periodic screening diagnosis and treatment (EPSDT) program',
  },

  /* 104 */
  {
    code: 'ET',
    description: 'Emergency services',
  },

  /* 105 */
  {
    code: 'EY',
    description: 'No physician or other licensed health care provider order for this item or service',
  },

  /* 106 */
  {
    code: 'F1',
    description: 'LEFT HAND, SECOND DIGIT',
  },

  /* 107 */
  {
    code: 'F2',
    description: 'LEFT HAND, THIRD DIGIT ',
  },

  /* 108 */
  {
    code: 'F3',
    description: 'LEFT HAND, FOURTH DIGIT',
  },

  /* 109 */
  {
    code: 'F4',
    description: 'LEFT HAND, FIFTH DIGIT ',
  },

  /* 110 */
  {
    code: 'F5',
    description: 'RIGHT HAND, THUMB',
  },

  /* 111 */
  {
    code: 'F6',
    description: 'RIGHT HAND, SECOND DIGIT ',
  },

  /* 112 */
  {
    code: 'F7',
    description: 'RIGHT HAND, THIRD DIGIT',
  },

  /* 113 */
  {
    code: 'F8',
    description: 'RIGHT HAND, FOURTH DIGIT ',
  },

  /* 114 */
  {
    code: 'F9',
    description: 'RIGHT HAND, FIFTH DIGIT',
  },

  /* 115 */
  {
    code: 'FA',
    description: 'LEFT HAND, THUMB ',
  },

  /* 116 */
  {
    code: 'FB',
    description: 'Item provided without cost to provider, supplier or practitioner, or full credit received for replaced device (examples, but not',
  },

  /* 117 */
  {
    code: 'FC',
    description: 'Partial credit received for replaced device',
  },

  /* 118 */
  {
    code: 'FP',
    description: 'Service provided as part of family planning program',
  },

  /* 119 */
  {
    code: 'G1',
    description: 'Most recent URR reading of less than 60',
  },

  /* 120 */
  {
    code: 'G2',
    description: 'Most recent URR reading of 60 to 64.9',
  },

  /* 121 */
  {
    code: 'G3',
    description: 'Most recent URR reading of 65 to 69.9',
  },

  /* 122 */
  {
    code: 'G4',
    description: 'Most recent URR reading of 70 to 74.9',
  },

  /* 123 */
  {
    code: 'G5',
    description: 'Most recent URR reading of 75 or greater',
  },

  /* 124 */
  {
    code: 'G6',
    description: 'ESRD patient for whom less than six dialysis sessions have been provided in a month',
  },

  /* 125 */
  {
    code: 'G7',
    description: 'Pregnancy resulted from rape or incest or pregnancy certified by physician as life threatening',
  },

  /* 126 */
  {
    code: 'G8',
    description: 'Monitored anesthesia care (MAC) for deep complex, complicated, or markedly invasive surgical procedure',
  },

  /* 127 */
  {
    code: 'G9',
    description: 'Monitored anesthesia care for patient who has history of severe cardio-pulmonary condition',
  },

  /* 128 */
  {
    code: 'GA',
    description: 'Waiver of liability statement issued as required by payer policy, individual case',
  },

  /* 129 */
  {
    code: 'GB',
    description: 'Claim being re-submitted for payment because it is no longer covered under a global payment demonstration',
  },

  /* 130 */
  {
    code: 'GC',
    description: 'This service has been performed in part by a resident under the direction of a teaching physician',
  },

  /* 131 */
  {
    code: 'GD',
    description: 'Units of service exceeds medically unlikely edit value and represents reasonable and necessary services',
  },

  /* 132 */
  {
    code: 'GE',
    description: 'This service has been performed by a resident without the presence of a teaching physician under the primary care exception',
  },

  /* 133 */
  {
    code: 'GF',
    description: 'Non-physician (e.g. nurse practitioner (NP), certified registered nurse anesthetist (CRNA), certified registered nurse (CRN), cl',
  },

  /* 134 */
  {
    code: 'GG',
    description: 'PERFORMANCE AND PAYMENT OF A SCREENING MAMMOGRAM AND DIAGNOSTIC MAMMOGRAM ON THE SAME PATIENT, SAME DAY',
  },

  /* 135 */
  {
    code: 'GH',
    description: 'DIAGNOSTIC MAMMOGRAM CONVERTED FROM SCREENING MAMMOGRAM ON SAME DAY',
  },

  /* 136 */
  {
    code: 'GJ',
    description: 'Opt out physician or practitioner emergency or urgent service',
  },

  /* 137 */
  {
    code: 'GK',
    description: 'Reasonable and necessary item/service associated with a ga or gz modifier',
  },

  /* 138 */
  {
    code: 'GL',
    description: 'Medically unnecessary upgrade provided instead of non-upgraded item, no charge, no advance beneficiary notice (ABN)',
  },

  /* 139 */
  {
    code: 'GM',
    description: 'Multiple patients on one ambulance trip',
  },

  /* 140 */
  {
    code: 'GN',
    description: 'Services delivered under an outpatient speech language pathology plan of care',
  },

  /* 141 */
  {
    code: 'GO',
    description: 'Services delivered under an outpatient occupational therapy plan of care',
  },

  /* 142 */
  {
    code: 'GP',
    description: 'Services delivered under an outpatient physical therapy plan of care',
  },

  /* 143 */
  {
    code: 'GQ',
    description: 'Via asynchronous telecommunications system',
  },

  /* 144 */
  {
    code: 'GR',
    description: 'This service was performed in whole or in part by a resident in a department of veterans affairs medical center or clinic, super',
  },

  /* 145 */
  {
    code: 'GS',
    description: 'Dosage of erythropoietin stimulating agent has been reduced and maintained in response to hematocrit or hemoglobin level',
  },

  /* 146 */
  {
    code: 'GT',
    description: 'Via interactive audio and video telecommunication systems',
  },

  /* 147 */
  {
    code: 'GU',
    description: 'Waiver of liability statement issued as required by payer policy, routine notice',
  },

  /* 148 */
  {
    code: 'GV',
    description: 'Attending physician not employed or paid under arrangement by the patients hospice provider',
  },

  /* 149 */
  {
    code: 'GW',
    description: 'Service not related to the hospice patients terminal condition',
  },

  /* 150 */
  {
    code: 'GX',
    description: 'Notice of liability issued, voluntary under payer policy',
  },

  /* 151 */
  {
    code: 'GY',
    description: 'Medicare Modifier',
  },

  /* 152 */
  {
    code: 'GZ',
    description: 'Item or service expected to be denied as not reasonable and necessary',
  },

  /* 153 */
  {
    code: 'H9',
    description: 'Court-ordered',
  },

  /* 154 */
  {
    code: 'HA',
    description: 'Child/adolescent program',
  },

  /* 155 */
  {
    code: 'HB',
    description: 'Adult program, non geriatric',
  },

  /* 156 */
  {
    code: 'HC',
    description: 'Adult program, geriatric',
  },

  /* 157 */
  {
    code: 'HD',
    description: 'Pregnant/parenting womens program',
  },

  /* 158 */
  {
    code: 'HE',
    description: 'Mental health program',
  },

  /* 159 */
  {
    code: 'HF',
    description: 'Substance abuse program',
  },

  /* 160 */
  {
    code: 'HG',
    description: 'Opioid addiction treatment program',
  },

  /* 161 */
  {
    code: 'HH',
    description: 'Integrated mental health/substance abuse program',
  },

  /* 162 */
  {
    code: 'HI',
    description: 'Integrated mental health and mental retardation/developmental disabilities program',
  },

  /* 163 */
  {
    code: 'HJ',
    description: 'Employee assistance program',
  },

  /* 164 */
  {
    code: 'HK',
    description: 'Specialized mental health programs for high-risk populations',
  },

  /* 165 */
  {
    code: 'HL',
    description: 'Intern',
  },

  /* 166 */
  {
    code: 'HM',
    description: 'Less than bachelor degree level',
  },

  /* 167 */
  {
    code: 'HN',
    description: 'Bachelors degree level',
  },

  /* 168 */
  {
    code: 'HO',
    description: 'Masters degree level',
  },

  /* 169 */
  {
    code: 'HP',
    description: 'Doctoral level',
  },

  /* 170 */
  {
    code: 'HQ',
    description: 'Group setting',
  },

  /* 171 */
  {
    code: 'HR',
    description: 'Family/couple with client present',
  },

  /* 172 */
  {
    code: 'HS',
    description: 'Family/couple without client present',
  },

  /* 173 */
  {
    code: 'HT',
    description: 'Multi-disciplinary team',
  },

  /* 174 */
  {
    code: 'HU',
    description: 'Funded by child welfare agency',
  },

  /* 175 */
  {
    code: 'HV',
    description: 'Funded state addictions agency',
  },

  /* 176 */
  {
    code: 'HW',
    description: 'Funded by state mental health agency',
  },

  /* 177 */
  {
    code: 'HX',
    description: 'Funded by county/local agency',
  },

  /* 178 */
  {
    code: 'HY',
    description: 'Funded by juvenile justice agency',
  },

  /* 179 */
  {
    code: 'HZ',
    description: 'Funded by criminal justice agency',
  },

  /* 180 */
  {
    code: 'J1',
    description: 'Competitive acquisition program no-pay submission for a prescription number',
  },

  /* 181 */
  {
    code: 'J2',
    description: 'Competitive acquisition program, restocking of emergency drugs after emergency administration',
  },

  /* 182 */
  {
    code: 'J3',
    description: 'Competitive acquisition program (CAP), drug not available through cap as written, reimbursed under average sales price methodolo',
  },

  /* 183 */
  {
    code: 'J4',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program that is furnished by a hospital upon discharge',
  },

  /* 184 */
  {
    code: 'JA',
    description: 'Administered intravenously',
  },

  /* 185 */
  {
    code: 'JB',
    description: 'Administered subcutaneously',
  },

  /* 186 */
  {
    code: 'JC',
    description: 'Skin substitute used as a graft',
  },

  /* 187 */
  {
    code: 'JD',
    description: 'Skin substitute not used as a graft',
  },

  /* 188 */
  {
    code: 'JW',
    description: 'Drug amount discarded/not administered to any patient',
  },

  /* 189 */
  {
    code: 'K0',
    description: 'Lower extremity prosthesis functional level 0 - does not have the ability or potential to ambulate or transfer safely with or wi',
  },

  /* 190 */
  {
    code: 'K1',
    description: 'Lower extremity prosthesis functional level 1 - has the ability or potential to use a prosthesis for transfers or ambulation on ',
  },

  /* 191 */
  {
    code: 'K2',
    description: 'Lower extremity prosthesis functional level 2 - has the ability or potential for ambulation with the ability to traverse low lev',
  },

  /* 192 */
  {
    code: 'K3',
    description: 'Lower extremity prosthesis functional level 3 - has the ability or potential for ambulation with variable cadence. Typical of th',
  },

  /* 193 */
  {
    code: 'K4',
    description: 'Lower extremity prosthesis functional level 4 - has the ability or potential for prosthetic ambulation that exceeds the basic am',
  },

  /* 194 */
  {
    code: 'KA',
    description: 'Add on option/accessory for wheelchair',
  },

  /* 195 */
  {
    code: 'KB',
    description: 'Beneficiary requested upgrade for ABN, more than 4 modifiers identified on claim',
  },

  /* 196 */
  {
    code: 'KC',
    description: 'Replacement of special power wheelchair interface',
  },

  /* 197 */
  {
    code: 'KD',
    description: 'Drug or biological infused through DME',
  },

  /* 198 */
  {
    code: 'KE',
    description: 'Bid under round one of the DMEPOS competitive bidding program for use with non-competitive bid base equipment',
  },

  /* 199 */
  {
    code: 'KF',
    description: 'Item designated by FDA as class III device',
  },

  /* 200 */
  {
    code: 'KG',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program number 1',
  },

  /* 201 */
  {
    code: 'KH',
    description: 'DMEPOS item, initial claim, purchase or first month rental',
  },

  /* 202 */
  {
    code: 'KI',
    description: 'DMEPOS item, second or third month rental',
  },

  /* 203 */
  {
    code: 'KJ',
    description: 'DMEPOS item, parenteral enteral nutrition (PEN) pump or capped rental, months four to fifteen',
  },

  /* 204 */
  {
    code: 'KK',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program number 2',
  },

  /* 205 */
  {
    code: 'KL',
    description: 'DMEPOS item delivered via mail',
  },

  /* 206 */
  {
    code: 'KM',
    description: 'Replacement of facial prosthesis including new impression/moulage',
  },

  /* 207 */
  {
    code: 'KN',
    description: 'Replacement of facial prosthesis using previous master model',
  },

  /* 208 */
  {
    code: 'KO',
    description: 'Single drug unit dose formulation',
  },

  /* 209 */
  {
    code: 'KP',
    description: 'First drug of a multiple drug unit dose formulation',
  },

  /* 210 */
  {
    code: 'KQ',
    description: 'Second or subsequent drug of a multiple drug unit dose formulation',
  },

  /* 211 */
  {
    code: 'KR',
    description: 'Rental item, billing for partial month',
  },

  /* 212 */
  {
    code: 'KS',
    description: 'Glucose monitor supply for diabetic beneficiary not treated with insulin',
  },

  /* 213 */
  {
    code: 'KT',
    description: 'Beneficiary resides in a competitive bidding area and travels outside that competitive bidding area and receives a competitive b',
  },

  /* 214 */
  {
    code: 'KU',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program number 3',
  },

  /* 215 */
  {
    code: 'KV',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program that is furnished as part of a professional service',
  },

  /* 216 */
  {
    code: 'KW',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program number 4',
  },

  /* 217 */
  {
    code: 'KX',
    description: 'Requirements specified in the medical policy have been met',
  },

  /* 218 */
  {
    code: 'KY',
    description: 'DMEPOS item subject to DMEPOS competitive bidding program number 5',
  },

  /* 219 */
  {
    code: 'KZ',
    description: 'New coverage not implemented by managed care',
  },

  /* 220 */
  {
    code: 'LC',
    description: 'LEFT CIRCUMFLEX CORONARY ARTERY (HOSPITALS USE WITH CODES 92980-92984, 92995, 92996) ',
  },

  /* 221 */
  {
    code: 'LD',
    description: 'LEFT ANTERIOR DESCENDING CORONARY ARTERY (HOSPITALS USE WITH CODES 92980-92984, 92995, 92996)',
  },

  /* 222 */
  {
    code: 'LL',
    description: 'Lease/rental (use the LL modifier when DME equipment rental is to be applied against the purchase price)',
  },

  /* 223 */
  {
    code: 'LM',
    description: 'Left main coronary artery',
  },

  /* 224 */
  {
    code: 'LR',
    description: 'Laboratory round trip',
  },

  /* 225 */
  {
    code: 'LS',
    description: 'FDA-monitored intraocular lens implant',
  },

  /* 226 */
  {
    code: 'LT',
    description: 'LEFT SIDE (USED TO IDENTIFY PROCEDURES PERFORMED ON THE LEFT SIDE OF THE BODY) ',
  },

  /* 227 */
  {
    code: 'M2',
    description: 'Medicare secondary payer (MSP)',
  },

  /* 228 */
  {
    code: 'MS',
    description: 'Six month maintenance and servicing fee for reasonable and necessary parts and labor which are not covered under any manufacture',
  },

  /* 229 */
  {
    code: 'NB',
    description: 'Nebulizer system, any type, FDA-cleared for use with specific drug',
  },

  /* 230 */
  {
    code: 'NC',
    description: 'NO CHARGE',
    custom: true,
  },

  /* 231 */
  {
    code: 'NR',
    description: 'New when rented (use the NR modifier when DME which was new at the time of rental is subsequently purchased)',
  },

  /* 232 */
  {
    code: 'NU',
    description: 'New equipment',
  },

  /* 233 */
  {
    code: 'P1',
    description: 'A NORMAL HEALTHY PATIENT ',
  },

  /* 234 */
  {
    code: 'P2',
    description: 'A PATIENT WITH MILD SYSTEMIC DISEASE ',
  },

  /* 235 */
  {
    code: 'P3',
    description: 'A PATIENT WITH SEVERE SYSTEMIC DISEASE ',
  },

  /* 236 */
  {
    code: 'P4',
    description: 'A PATIENT WITH SEVERE SYSTEMIC DISEASE THAT IS A CONSTANT THREAT TO LIFE ',
  },

  /* 237 */
  {
    code: 'P5',
    description: 'A MORIBUND PATIENT WHO IS NOT EXPECTED TO SURVIVE WITHOUT THE OPERATION',
  },

  /* 238 */
  {
    code: 'P6',
    description: 'A DECLARED BRAIN-DEAD PATIENT WHOSE ORGANS ARE BEING REMOVED FOR DONOR PURPOSES',
  },

  /* 239 */
  {
    code: 'PA',
    description: 'Surgical or other invasive procedure on wrong body part',
  },

  /* 240 */
  {
    code: 'PB',
    description: 'Surgical or other invasive procedure on wrong patient',
  },

  /* 241 */
  {
    code: 'PC',
    description: 'Wrong surgery or other invasive procedure on patient',
  },

  /* 242 */
  {
    code: 'PD',
    description: 'Diagnostic or related non diagnostic item or service provided in a wholly owned or operated entity to a patient who is admitted ',
  },

  /* 243 */
  {
    code: 'PI',
    description: 'Positron emission tomography (PET) or PET/computed tomography (CT) to inform the initial treatment strategy of tumors that are b',
  },

  /* 244 */
  {
    code: 'PL',
    description: 'Progressive addition lenses',
  },

  /* 245 */
  {
    code: 'PR',
    description: 'No description for modifier',
  },

  /* 246 */
  {
    code: 'PS',
    description: 'Positron emission tomography (PET) or PET/computed tomography (CT) to inform the subsequent treatment strategy of cancerous tumo',
  },

  /* 247 */
  {
    code: 'PT',
    description: 'Colorectal cancer screening test; converted to diagnostic test or other procedure',
  },

  /* 248 */
  {
    code: 'Q0',
    description: 'Investigational clinical service provided in a clinical research study that is in an approved clinical research study',
  },

  /* 249 */
  {
    code: 'Q1',
    description: 'Routine clinical service provided in a clinical research study that is in an approved clinical research study',
  },

  /* 250 */
  {
    code: 'Q2',
    description: 'Hcfa/ord demonstration project procedure/service',
  },

  /* 251 */
  {
    code: 'Q3',
    description: 'Live kidney donor surgery and related services',
  },

  /* 252 */
  {
    code: 'Q4',
    description: 'Service for ordering/referring physician qualifies as a service exemption',
  },

  /* 253 */
  {
    code: 'Q5',
    description: 'Service furnished by a substitute physician under a reciprocal billing arrangement',
  },

  /* 254 */
  {
    code: 'Q6',
    description: 'Locum Tenens ',
  },

  /* 255 */
  {
    code: 'Q7',
    description: 'One Class A finding',
  },

  /* 256 */
  {
    code: 'Q8',
    description: 'Two Class B findings',
  },

  /* 257 */
  {
    code: 'Q9',
    description: 'One Class B and two Class C findings',
  },

  /* 258 */
  {
    code: 'QC',
    description: 'Single channel monitoring',
  },

  /* 259 */
  {
    code: 'QD',
    description: 'Recording and storage in solid state memory by a digital recorder',
  },

  /* 260 */
  {
    code: 'QE',
    description: 'Prescribed amount of oxygen is less than 1 liter per minute (LPM)',
  },

  /* 261 */
  {
    code: 'QF',
    description: 'Prescribed amount of oxygen exceeds 4 liters per minute (LPM) and portable oxygen is prescribed',
  },

  /* 262 */
  {
    code: 'QG',
    description: 'Prescribed amount of oxygen is greater than 4 liters per minute(LPM)',
  },

  /* 263 */
  {
    code: 'QH',
    description: 'Oxygen conserving device is being used with an oxygen delivery system',
  },

  /* 264 */
  {
    code: 'QJ',
    description: 'Services/items provided to a prisoner or patient in state or local custody, however the state or local government, as applicable',
  },

  /* 265 */
  {
    code: 'QK',
    description: 'Medical direction of two, three, or four concurrent anesthesia procedures involving qualified individuals',
  },

  /* 266 */
  {
    code: 'QL',
    description: 'Patient pronounced dead after ambulance called',
  },

  /* 267 */
  {
    code: 'QM',
    description: 'AMBULANCE SERVICE PROVIDED UNDER ARRANGEMENT BY A PROVIDER OF SERVICES ',
  },

  /* 268 */
  {
    code: 'QN',
    description: 'AMBULANCE SERVICE FURNISHED DIRECTLY BY A PROVIDER OF SERVICES ',
  },

  /* 269 */
  {
    code: 'QP',
    description: 'Documentation is on file showing that the laboratory test(s) was ordered individually or ordered as a CPT-recognized panel other',
  },

  /* 270 */
  {
    code: 'QS',
    description: 'Monitored anesthesia care service',
  },

  /* 271 */
  {
    code: 'QT',
    description: 'Recording and storage on tape by an analog tape recorder',
  },

  /* 272 */
  {
    code: 'QW',
    description: 'CLIA waived test',
  },

  /* 273 */
  {
    code: 'QX',
    description: 'CRNA service: with medical direction by a physician',
  },

  /* 274 */
  {
    code: 'QY',
    description: 'Medical direction of one certified registered nurse anesthetist (CRNA) by an anesthesiologist',
  },

  /* 275 */
  {
    code: 'QZ',
    description: 'CRNA service: without medical direction by a physician',
  },

  /* 276 */
  {
    code: 'RA',
    description: 'Replacement of a DME, orthotic or prosthetic item',
  },

  /* 277 */
  {
    code: 'RB',
    description: 'Replacement of a part of a DME, orthotic or prosthetic item furnished as part of a repair',
  },

  /* 278 */
  {
    code: 'RC',
    description: 'RIGHT CORONARY ARTERY (HOSPITALS USE WITH CODES 92980-92984, 92995, 92996) ',
  },

  /* 279 */
  {
    code: 'RD',
    description: 'Drug provided to beneficiary, but not administered incident-to',
  },

  /* 280 */
  {
    code: 'RE',
    description: 'Furnished in full compliance with FDA-mandated risk evaluation and mitigation strategy (rems)',
  },

  /* 281 */
  {
    code: 'RI',
    description: 'Ramus intermedius coronary artery',
  },

  /* 282 */
  {
    code: 'RR',
    description: 'Rental (use the RR modifier when DME is to be rented)',
  },

  /* 283 */
  {
    code: 'RT',
    description: 'RIGHT SIDE (USED TO IDENTIFY PROCEDURES PERFORMED ON THE RIGHT SIDE OF THE BODY) ',
  },

  /* 284 */
  {
    code: 'SA',
    description: 'Nurse practitioner rendering service in collaboration with a physician',
  },

  /* 285 */
  {
    code: 'SB',
    description: 'Nurse midwife',
  },

  /* 286 */
  {
    code: 'SC',
    description: 'Medically necessary service or supply',
  },

  /* 287 */
  {
    code: 'SD',
    description: 'Services provided by registered nurse with specialized, highly technical home infusion training',
  },

  /* 288 */
  {
    code: 'SE',
    description: 'State and/or federally-funded programs/services',
  },

  /* 289 */
  {
    code: 'SF',
    description: 'Second opinion ordered by a professional review organization (PRO) per section 9401, p. L. 99-272 (100% reimbursement - no Medic',
  },

  /* 290 */
  {
    code: 'SG',
    description: 'Ambulatory surgical center (ASC) facility service',
  },

  /* 291 */
  {
    code: 'SH',
    description: 'Second concurrently administered infusion therapy',
  },

  /* 292 */
  {
    code: 'SJ',
    description: 'Third or more concurrently administered infusion therapy',
  },

  /* 293 */
  {
    code: 'SK',
    description: 'Member of high risk population (use only with codes for immunization)',
  },

  /* 294 */
  {
    code: 'SL',
    description: 'State supplied vaccine',
  },

  /* 295 */
  {
    code: 'SM',
    description: 'Second surgical opinion',
  },

  /* 296 */
  {
    code: 'SN',
    description: 'Third surgical opinion',
  },

  /* 297 */
  {
    code: 'SQ',
    description: 'Item ordered by home health',
  },

  /* 298 */
  {
    code: 'SS',
    description: 'Home infusion services provided in the infusion suite of the IV therapy provider',
  },

  /* 299 */
  {
    code: 'ST',
    description: 'Related to trauma or injury',
  },

  /* 300 */
  {
    code: 'SU',
    description: 'Procedure performed in physicians office (to denote use of facility and equipment)',
  },

  /* 301 */
  {
    code: 'SV',
    description: 'Pharmaceuticals delivered to patients home but not utilized',
  },

  /* 302 */
  {
    code: 'SW',
    description: 'Services provided by a certified diabetic educator',
  },

  /* 303 */
  {
    code: 'SY',
    description: 'Persons who are in close contact with member of high-risk population (use only with codes for immunization)',
  },

  /* 304 */
  {
    code: 'T1',
    description: 'LEFT FOOT, SECOND DIGIT',
  },

  /* 305 */
  {
    code: 'T2',
    description: 'LEFT FOOT, THIRD DIGIT ',
  },

  /* 306 */
  {
    code: 'T3',
    description: 'LEFT FOOT, FOURTH DIGIT',
  },

  /* 307 */
  {
    code: 'T4',
    description: 'LEFT FOOT, FIFTH DIGIT ',
  },

  /* 308 */
  {
    code: 'T5',
    description: 'RIGHT FOOT, GREAT TOE',
  },

  /* 309 */
  {
    code: 'T6',
    description: 'RIGHT FOOT, SECOND DIGIT ',
  },

  /* 310 */
  {
    code: 'T7',
    description: 'RIGHT FOOT, THIRD DIGIT',
  },

  /* 311 */
  {
    code: 'T8',
    description: 'RIGHT FOOT, FOURTH DIGIT ',
  },

  /* 312 */
  {
    code: 'T9',
    description: 'RIGHT FOOT, FIFTH DIGIT',
  },

  /* 313 */
  {
    code: 'TA',
    description: 'LEFT FOOT, GREAT TOE ',
  },

  /* 314 */
  {
    code: 'TC',
    description: 'Technical component',
  },

  /* 315 */
  {
    code: 'TD',
    description: 'RN',
  },

  /* 316 */
  {
    code: 'TE',
    description: 'LPN/LVN',
  },

  /* 317 */
  {
    code: 'TF',
    description: 'Intermediate level of care',
  },

  /* 318 */
  {
    code: 'TG',
    description: 'Complex/high tech level of care',
  },

  /* 319 */
  {
    code: 'TH',
    description: 'Obstetrical treatment/services, prenatal or postpartum',
  },

  /* 320 */
  {
    code: 'TJ',
    description: 'Program group, child and/or adolescent',
  },

  /* 321 */
  {
    code: 'TK',
    description: 'Extra patient or passenger, non-ambulance',
  },

  /* 322 */
  {
    code: 'TL',
    description: 'Early intervention/individualized family service plan (IFSP)',
  },

  /* 323 */
  {
    code: 'TM',
    description: 'Individualized education program (IEP)',
  },

  /* 324 */
  {
    code: 'TN',
    description: 'Rural/outside providers customary service area',
  },

  /* 325 */
  {
    code: 'TP',
    description: 'Medical transport, unloaded vehicle',
  },

  /* 326 */
  {
    code: 'TQ',
    description: 'Basic life support transport by a volunteer ambulance provider',
  },

  /* 327 */
  {
    code: 'TR',
    description: 'School-based individualized education program (IEP) services provided outside the public school district responsible for the stu',
  },

  /* 328 */
  {
    code: 'TS',
    description: 'Follow-up service',
  },

  /* 329 */
  {
    code: 'TT',
    description: 'Individualized service provided to more than one patient in same setting',
  },

  /* 330 */
  {
    code: 'TU',
    description: 'Special payment rate, overtime',
  },

  /* 331 */
  {
    code: 'TV',
    description: 'Special payment rates, holidays/weekends',
  },

  /* 332 */
  {
    code: 'TW',
    description: 'Back-up equipment',
  },

  /* 333 */
  {
    code: 'U1',
    description: 'Medicaid level of care 1, as defined by each state',
  },

  /* 334 */
  {
    code: 'U2',
    description: 'Medicaid level of care 2, as defined by each state',
  },

  /* 335 */
  {
    code: 'U3',
    description: 'Medicaid level of care 3, as defined by each state',
  },

  /* 336 */
  {
    code: 'U4',
    description: 'Medicaid level of care 4, as defined by each state',
  },

  /* 337 */
  {
    code: 'U5',
    description: 'Medicaid level of care 5, as defined by each state',
  },

  /* 338 */
  {
    code: 'U6',
    description: 'Medicaid level of care 6, as defined by each state',
  },

  /* 339 */
  {
    code: 'U7',
    description: 'Medicaid level of care 7, as defined by each state',
  },

  /* 340 */
  {
    code: 'U8',
    description: 'Medicaid level of care 8, as defined by each state',
  },

  /* 341 */
  {
    code: 'U9',
    description: 'Medicaid level of care 9, as defined by each state',
  },

  /* 342 */
  {
    code: 'UA',
    description: 'Medicaid level of care 10, as defined by each state',
  },

  /* 343 */
  {
    code: 'UB',
    description: 'Medicaid level of care 11, as defined by each state',
  },

  /* 344 */
  {
    code: 'UC',
    description: 'Medicaid level of care 12, as defined by each state',
  },

  /* 345 */
  {
    code: 'UD',
    description: 'Medicaid level of care 13, as defined by each state',
  },

  /* 346 */
  {
    code: 'UE',
    description: 'Used durable medical equipment',
  },

  /* 347 */
  {
    code: 'UF',
    description: 'Services provided in the morning',
  },

  /* 348 */
  {
    code: 'UG',
    description: 'Services provided in the afternoon',
  },

  /* 349 */
  {
    code: 'UH',
    description: 'Services provided in the evening',
  },

  /* 350 */
  {
    code: 'UJ',
    description: 'Services provided at night',
  },

  /* 351 */
  {
    code: 'UK',
    description: 'Services provided on behalf of the client to someone other than the client (collateral relationship)',
  },

  /* 352 */
  {
    code: 'UN',
    description: 'Two patients served',
  },

  /* 353 */
  {
    code: 'UP',
    description: 'Three patients served',
  },

  /* 354 */
  {
    code: 'UQ',
    description: 'Four patients served',
  },

  /* 355 */
  {
    code: 'UR',
    description: 'Five patients served',
  },

  /* 356 */
  {
    code: 'US',
    description: 'Six or more patients served',
  },

  /* 357 */
  {
    code: 'V5',
    description: 'Vascular catheter (alone or with any other vascular access)',
  },

  /* 358 */
  {
    code: 'V6',
    description: 'Arteriovenous graft (or other vascular access not including a vascular catheter)',
  },

  /* 359 */
  {
    code: 'V7',
    description: 'Arteriovenous fistula only (in use with two needles)',
  },

  /* 360 */
  {
    code: 'VP',
    description: 'Aphakic patient',
  },

  /* 361 */
  {
    code: 'XE',
    description: 'Separate encounter',
  },

  /* 362 */
  {
    code: 'XP',
    description: 'Separate practitioner',
  },

  /* 363 */
  {
    code: 'XS',
    description: 'Separate structure',
  },

  /* 364 */
  {
    code: 'XU',
    description: 'Unusual non-overlapping service',
  },

    /* 365 */
    {
      code: 'FS',
      description: 'FS',
    },
];

export function findCptModifier(id: string): CptModifier | null {
  if (!id) {
    return null;
  }
  id = id.trim().toUpperCase();

  if(!id.length){
    return null;
  }

  return cptModifiers.filter((m) => m.code === id)[0];
}

const modifiersByLocation: Record<string, CptModifier[]> = {};

export async function setModifiers(locationCode:string, serviceDate:string) {
  const key = locationCode + serviceDate;
  if(modifiersByLocation[key]?.length){
    cptModifiers = modifiersByLocation[key];
    return;
  }
  const r = await getmodifiers({locationCode, serviceDate});
  if(r.length ){
    modifiersByLocation[key] = r;
    cptModifiers = r;
  }
}